module.exports = __webpack_public_path__ + "static/media/Birds.74e69de2.ogg";